import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage3UpImagesIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryPackage3UpImagesIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["image"]);
}
